define('editor/edit/layers/edit/basicGroup',['plugins/http', 'durandal/app', 'jquery', 'knockout', 'knockout-mapping', 'tinycolorpicker'], function (http, app, $, ko, komapping) {
    var viewmodel = function () {
        var self = this;

        self.name = ko.observable();
        
        self.activate = function (editorMapId, group, layers, backToListFunc) {
            self.editorMapId = editorMapId;
            self.group = group;
            self.name(group.name());
            self.exit = backToListFunc;
        };

        self.saveCommand = function () {
            self.group.name(self.name());

            self.save()
                .then(function () {
                    self.isDirty = false;
                    self.exit();
                })
                .fail(app.showError);
        };

        self.cancelCommand = function () {
            self.exit();
        };

        self.save = function () {
            var url = '/api/editor/layers/group/details',
                data = {
                    editorMapId: self.editorMapId,
                    groupId: self.group.id(),
                    groupName: self.group.name(),
                    groupCollapsed: self.group.isCollapsed(),
                    childLayerStates: {}
                };

            return http.post(url, data)
                .fail(app.showError);
        };
    };

    return viewmodel;
});

